const v2RouteList = [
  {
    path: "/v2jsbrain", //见山大脑
    name: "v2jsbrain",
    component: (/* webpackChunkName: "v2jsbrain" */) =>
      import("./jsbrain/index.vue"),
  },
  {
    path: "/databoard", //见山大脑
    name: "databoard",
    component: (/* webpackChunkName: "v2jsbrain" */) =>
      import("./jsbrain/dataBoard/index.vue"),
  },
  {
    path: "/analysisWeb", //见山大脑
    name: "analysisWeb",
    component: (/* webpackChunkName: "v2jsbrain" */) =>
      import("./jsbrainAnalysis/analysisWeb/index.vue"),
  },
  {
    path: "/v2operation", //商圈分析
    name: "v2operation",
    component: () =>
      /* webpackChunkName: "v2operation" */
      import("./businessCricle/operation/index.vue"),
  },
  {
    path: "/v2compare", //商圈对比
    name: "v2compare",
    component: (/* webpackChunkName: "v2operation" */) =>
      import("./businessCricle/compare/index.vue"),
  },
  {
    path: "/v2archives", //档案管理
    name: "v2archives",
    component: (/* webpackChunkName: "v2archives" */) =>
      import("./fileManagement/archives/index.vue"),
  },
  {
    path: "/v2archivesDetail", //档案管理 档案室
    name: "v2archivesDetail",
    component: (/* webpackChunkName: "v2archivesDetail" */) =>
      import("./fileManagement/archivesDetail/index.vue"),
  },
  {
    path: "/v2water", //档案管理 档案室
    name: "v2water",
    component: (/* webpackChunkName: "v2water" */) =>
      import("./water/index.vue"),
  },
  {
    path: "/v2archive", //档案管理 档案室
    name: "v2archive",
    component: (/* webpackChunkName: "v2water" */) =>
      import("./archive/index.vue"),
  },
];
export default v2RouteList;
